// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"45bbb9db","453":"eaf38680","554":"01e5c3f0","950":"d2dc68ec"}[chunkId] + ".chunk.js";
};